<template>
  <div class="layout shop_warp" v-if="companyInfo">
      <div class="shop_top">
        <img :src="companyInfo.exInfo.logo" v-load="'oLogo'">
        <div class="shop_info">
          <p class="shop_title">{{companyInfo.exInfo.compName}}</p>
          <p v-if="companyInfo.exInfo.exhibitionName">确认参展：{{companyInfo.exInfo.exhibitionName}}</p>
          <p v-if="category">类别：{{category}}</p>
        </div>
        <div class="bro_atten">
          <i class="iconfont icon-huabanfuben" ></i>
          <span class="rig30">{{companyInfo.exInfo.followCount}}</span>
          <i class="iconfont icon-zhiboguankanshu" ></i>
          <span>{{getCount(companyInfo.exInfo.viewCount)}}</span>
        </div>
      </div>
      <div class="fenge"></div>
      <div class="shop_con">
        <van-tabs class="content_nav" @change="tabsChange"  animated lazy-render line-height="2px"  line-width="0.88rem" color="#f85b0f" title-inactive-color="#333"  v-model="activeName"  swipeable>
          <!-- 推荐内容 -->
          <van-tab  name="recom">
            <template #title >
              <div class="con_nav_title">
                <p class="title_text">推荐</p>
              </div>
            </template>
            <van-list
              class="recom_con"
              v-model="proLoading"
              :finished="proFinished"
              finished-text="没有更多了"
              @load="proLoad"
            >
              <template v-for="(item,index) in companyInfo.proList" >
                <div class="pro_con_item" @click="LinkProduct(item.id)" v-if="item.isDisplay" :key="'p'+index" >
                  <div class="img_div">
                    <img :src="item.banner[0]" v-if="item.banner[0]" v-load="'oShopPro'">
                    <img src="@/assets/img/empty.png" v-else>
                  </div>
                  <div class="pro_bottom">
                    <p class="pro_title">{{item.name}}</p>
                    <p class="con_info">{{item.selling}}</p>
                  </div>
                </div>
              </template>
            </van-list>
          </van-tab>
          <!-- 产品内容 -->
          <van-tab name="product">
            <template #title >
              <div class="con_nav_title">
                <p class="title_text">产品</p>
              </div>
            </template>
            <van-list
              class="pro_con"
              v-model="proLoading"
              :finished="proFinished"
              finished-text="没有更多了"
              @load="proLoad"
              :offset="50"
            > 
              <div class="pro_con_item" v-for="(item,index) in proList" :key="'c'+index" @click="LinkProduct(item.id)">
                <div class="img_div">
                  <img :src="item.banner[0]" v-if="item.banner[0]">
                  <img src="@/assets/img/empty.png" v-else>
                </div>
                <div class="pro_bottom">
                  <p class="pro_title">{{item.name}}</p>
                  <p class="con_info" >{{item.selling}}</p>
                </div>
              </div>
            </van-list>
            <div >
              
            </div>
          </van-tab>
          <!-- 企业内容 -->
          <van-tab  name="company">
            <template #title >
              <div class="con_nav_title">
                <p class="title_text">企业</p>
              </div>
            </template>
            <div class="company_con">
              <p v-html="$service.replaceSpeace(companyInfo.exInfo.summaryZh)"></p>
            </div>
          </van-tab>
          
        </van-tabs>
      </div>
      <div class="shop_footer">
        <div class="f_item" @click="LinkExhibitionDetails(exhibitorId)">
          <i class="iconfont icon-chakanxiangqing"></i>
          <p>专题页</p>
        </div>
        <div class="f_item love" @click="delLove" v-if="isFollower">
          <i class="iconfont icon-love"></i>
          <p>关注</p>
        </div>
        <div class="f_item" v-else @click="addLove">
          <i class="iconfont icon-guanzhu-xian"></i>
          <p>关注</p>
        </div>
        <div class="f_item" @click="share">
          <i class="iconfont icon-fenxiang2" ></i>
          <p>分享</p>
        </div>
        <div class="f_btn">
          <van-button block @click="inquiry" color="linear-gradient(to right, #ffa600, #ffba00)">询盘</van-button>
        </div>
      </div>
      <!-- 询盘 -->
      <inquiry ref="inquiry"></inquiry>
      <!-- 分享 -->
      <liveShare ref="liveShare"></liveShare>
  </div>
</template>

<script>
import inquiry from "@components/inquiry";
import liveShare from "@/components/live-share/index";
import {mapGetters, mapActions} from "vuex";
export default {
  name: "shop_warp",
  components:{
    inquiry,
    liveShare
  },
  data() {
    return {
      activeName:'',
      proLoading:false,  //产品动态加载状态
      proFinished:false, //产品加载是否完成状态
      proList:[],         //产品列表
      companyInfo:null,
      category:null, // 类别
      page:1,
      size:20,
      proMsg:null,
      isFollower:false,
      shareV:{
        content:'',
        poster:'',
      },
      isShareV:false
    } 
  },
  computed:{
    ...mapGetters({
      exhibitorId:'company/getExhibitorId',
      companyId:'company/getCompanyId',
      userId:'getUserId',
      userInfo: "getUserInfo",
      exhibitionId:'getExhibitionId'
    }) 
  },
  created(){
    let exhibitorId = this.$route.query.exhibitorId;
    this.$store.commit('company/setExhibitorId',exhibitorId);
    this.init();
  },
  methods:{
    ...mapActions({
      getCompany:'company/getCompany',
      getProListByCompId:'company/getProListByCompId',
      getProListByTj:'company/getProListByTj',
      getAllCompany:'company/getAllCompany',
      LinkProduct:'linkTo/LinkProduct',
      LinkExhibitionDetails:'linkTo/LinkExhibitionDetails',
      addCompLove:'company/addCompLove',
      delCompLove:'company/delCompLove',
      addCompView:'company/addCompView',
      getShareConfig:'wxShare/getShareConfig'
    }),
    async init(){
      let body = {
        id:this.exhibitorId,
        userId:this.userId || null,
      }
      this.companyInfo =  await this.getAllCompany(body);
      this.companyInfo.proList.map(c =>{
        if (c.banner.search(/^\[/) !== -1) {
            c.banner = JSON.parse(c.banner);
        } else {
            c.banner = [];
        }
      })
      this.isFollower = this.companyInfo.isFollower;
      this.$nextTick(()=>{
        this.getShareData(this.companyInfo.exInfo);
      })
      console.log(this.companyInfo,'this.companyInfo');
      document.title =  this.companyInfo.exInfo.shortName || this.companyInfo.exInfo.compName;
      let MyCategory  =  this.companyInfo.exInfo.category;
      if(MyCategory && MyCategory.indexOf("{") !== -1) {
        const cate = JSON.parse(MyCategory);
        const cateArr = [];
        if (cate.Id) {
          cateArr.push(cate.Value);
          if (cate.List && cate.List[0]) { 
            cateArr.push(cate.List[0].Value);
            if (cate.List[0].List) {
              cateArr.push(cate.List[0].List[0].Value);
            }
          }
        }
        this.category = cateArr.join('/');
        // console.log(this.category,'this.category')
      }
      this.addView();
      this.getProList();
      this.checkForm();
    },
    checkForm(){
      let userInfo = {
          name: this.userInfo.nickName || this.userInfo.name,
          avatarUrl: this.userInfo.avatarUrl
        };
      if(this.$route.query.hotId){
        this.$store.commit('wxShare/setFromType',2);  // 判断是否来源于热榜
        let body = {
          popularzeId: this.$route.query.hotId,
          userId: this.userInfo.userId,
          userInfo: JSON.stringify(userInfo),
          fromType: 2,
        }
        this.$store.commit('wxShare/setFromData',body);
      } else {
        this.$store.commit('wxShare/setFromType',1);
        let body = {
          compId: this.companyId,
          exhibitionId: this.exhibitionId,
          exhibitorId: this.exhibitorId,
          userId: this.userInfo.userId,
          userInfo: JSON.stringify(userInfo),
          fromType: 1,
        }
        this.$store.commit('wxShare/setFromData',body);
      }
    },
    async getProList(){
        let body = {
          exhibitorId: this.exhibitorId,
          "page": this.page,
          "size": this.size
        };
       this.proMsg = await this.getProListByTj(body);
       this.proList = [...this.proList,...this.proMsg.items];
       if(this.proMsg.hasNextPage) { // 是否还有下一页
          this.proLoading= false;
          this.proFinished=false;
       } else {
         this.proFinished = true;
         this.proLoading = false;
       }
    },
    addView(){
      // 添加浏览记录
      let userInfo = {
        nickName: this.userInfo.nickName,
        avatarUrl: this.userInfo.avatarUrl
      };
      let body = {
        compId: this.companyId,
        exhibitionId: this.exhibitionId,
        exhibitorId: this.exhibitorId,
        userId: this.userId,
        userInfo: JSON.stringify(userInfo)
      };
      this.addCompView(body);
    },
    async addLove() {
      // 展商关注
      let userInfo = {
        nickName: this.userInfo.nickName,
        avatarUrl: this.userInfo.avatarUrl
      };
      let body = {
        compId: this.companyId,
        exhibitionId: this.exhibitionId,
        exhibitorId: this.exhibitorId,
        userId: this.userId,
        userInfo: JSON.stringify(userInfo)
      };
      let result = await this.addCompLove(body);
      console.log(result,'213')
      if (result.result) {
        this.isFollower = true;
        this.$toast.success('已关注');
      } else {
        this.isFollower = false;
        this.$toast.success(result.message);
      }
    },

    async delLove() {
      // 取消关注
      let body = {
        exhibitorId: this.exhibitorId,
        userId: this.userId,
      };
      let result = await this.delCompLove(body);
      console.log(result,'213')
      if (result.result) {
        this.isFollower = false;
        this.$toast.success('取消关注');
      } else {
        this.isFollower = true;
        this.$toast.success(result.message);
      }
    },
    
    // 人数超过w换算
    getCount(param) {
      let count = 0;
      if (param > 10000) {
        count = (param / 10000).toFixed(1);
        if (String(count)[count.length - 1] == 0) {
          count = (count / 1).toFixed(0);
        }
        return count + "w";
      }
      return param;
    },
    //产品加载
    proLoad(){
      if (this.proFinished) return;
      this.page = this.page + 1;
      this.proLoading= true;
      this.getProList();
    },
    //tab标签页改变
    tabsChange(data){
      switch (data) {
        case 'product':{
          this.proList=[];
          this.page = 1;
          this.size = 20;
          this.getProList();
          break;
        }
        case 'recom':{
          break;
        }
        default:
          break;
      }
    },
    //询盘点击  
    inquiry(){
      this.$refs["inquiry"].open();
    },
    //专题页
    specialPage(){
      this.$router.push('/exhibition-details')
    },
    async getShareVal(){
      let res = await this.getShareConfig(this.exhibitorId);
      if(res&&res){
        this.shareV=JSON.parse(res);
      }
      this.isShareV=true;
    },
    //分享点击
    async share(){
      if(!this.isShareV){
        await this.getShareVal();
      }
      let addr='';
      if(this.companyInfo.exInfo.province){
        addr=this.companyInfo.exInfo.province;
      }
      if(this.companyInfo.exInfo.city){
        addr+='·'+this.companyInfo.exInfo.city;
      }
      let opt={
        title:'给您推荐一家优质展商',
        bannerTitle:this.companyInfo.exInfo.compName,
        subhead:addr,
        bannerUrl:this.shareV.poster?this.shareV.poster:'default',
      }
      this.$nextTick(()=>{
        this.$refs['liveShare'].open(opt);
      })
      await true
    },
    async getShareData(data){
      await this.getShareVal();
      let shareData={
        title:this.shareV.content?this.shareV.content:'诚邀您参观 '+data.compName+' 线上展台',
        desc:data.summaryZh||'',
        imgUrl:data.logo
      }
      this.$nextTick(()=>{
        this.$refs.liveShare.shareTo(shareData);
      })
    },
  },
  destroyed() {
    this.$store.commit('wxShare/setFromData',null);
    this.$store.commit('wxShare/setFromType',0); 
  },
};
</script>

<style lang="scss" scoped>
.shop_warp{
  background: #fff;
  padding: 0.3rem 0 0.99rem;
  .shop_top{
    display: flex;
    height: 1rem;
    margin-bottom: 0.3rem;
    padding: 0 0.24rem;
    img{
      margin-right: 0.2rem;
      height: 1rem;
      width: 1rem;
      border-radius: 0.08rem;
      // object-fit: cover;
      border: 1px solid #dddddd;
    }
    .shop_info{
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      max-width: 54%;
      p{
        font-size: 0.2rem;
        color: #333;
        white-space:nowrap;
        text-overflow:ellipsis;
        overflow:hidden;
        &.shop_title{
          font-size: 0.26rem;
          font-weight: 400;
        }
      }
    }
    .bro_atten{
      color:#999999;
      margin-left: auto;
      span{
        font-size: 0.22rem;
        &.rig30{
          margin-right: 0.3rem;
        }
      }
      .iconfont{
        vertical-align: middle;
        font-size: 0.32rem;
      }
    }
    
  }
  .fenge{
    width: 100vw;
    height: 0.2rem;
    background: #f5f5f5;
  }
  .shop_con{
    //nav
    &::v-deep .content_nav{
      .van-tabs__wrap{
        margin-bottom: 0.15rem;
        .van-tabs__nav{
          .van-tabs__line{
            background: linear-gradient(to right, #ff416c,#ff4b2b);
          }
          .van-tab--active{
            .title_text{
              display: inline-block;
              background-image: linear-gradient(to right,#ff416c,#ff4b2b);
              -webkit-background-clip:text;
              color: transparent;
            }
          }
        }
      }
      .van-list__finished-text,.van-list__loading{
        width: 100%;
        line-height: 0.3rem;
        margin:0.45rem auto 0.15rem;
        font-size: 0.24rem;
      }
      .van-tabs__content{
        min-height:calc(100vh - 4.5rem);
      }
    }
    //产品内容
    .pro_con,.recom_con{
      display: flex;
      flex-wrap: wrap;  
      justify-content: space-between;
      padding: 0 0.24rem;
      .pro_con_item{
        // width: 3.4rem;
        width: 48.45%;
        border-radius: 3px 3px 0 0;
        overflow: hidden;
        background: #fff;
        margin-bottom: 0.22rem;
        color: #333;
        border: 1px solid #dce4ec;
        .img_div{
          position: relative;
          width: 100%;
          height: 0px;
          padding-top: 100%;
          img{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            // object-fit: cover;
          }
        }
        
        .pro_bottom{
          border-top: 1px solid #dce4ec;
          border-radius:0 0 3px 3px;
          padding-bottom: 0.1rem;
          height: 0.8rem;
          .pro_title{
            padding:  0.05rem 0.1rem 0.02rem 0.1rem;
            white-space: nowrap;  
            text-overflow:ellipsis; 
            overflow:hidden;
          }
          .con_info{
            padding: 0 0.05rem 0 0.1rem;
            font-size: 0.2rem;
            color: #666; 
            white-space: initial;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
    //企业内容
    .company_con{
      color: #333;
      padding: 0 0.3rem;
      min-height:calc(100vh - 4.5rem);
      p{
        line-height: 0.36rem;
      }
      img{
        width: 100%;
        margin: 0.3rem 0;
        border-radius: 0.06rem;
      }
    }
  }
  .shop_footer{
    display: flex;
    height: 0.99rem;
    width: 100%;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    border-top: 1px solid #ebebeb;
     
    box-shadow: 0px -3px 10px rgba(235,235,235,0.2);
    .f_item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      color:#808080 ;
      padding-top: 0.05rem;
      border-right: 1px solid #eee;
      &:first-child{
        color:#f85b0f;
      }
      width:1.09rem;
      .iconfont{
        font-size: 0.58rem;
      }
      p{
        font-size: 0.2rem;
        position: relative;
        top: -0.1rem;
      }
    }
    .f_btn{
      flex-grow:1;
      padding: 0.13rem  0.24rem;
      .van-button{
        height: 0.72rem;
        line-height: 0.72rem;
        span{
          font-size: 0.28rem;
        }
      }
    }
  }
}
.love{
  .iconfont,p{
    color:#f85b0f;
  }
}
</style>
